/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Linkedlisting1Inputs */

const en_linkedlisting1 = /** @type {(inputs: Linkedlisting1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Linked Listing`)
};

const de_linkedlisting1 = /** @type {(inputs: Linkedlisting1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verknüpfter Ort`)
};

/**
* | output |
* | --- |
* | "Linked Listing" |
*
* @param {Linkedlisting1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const linkedlisting1 = /** @type {((inputs?: Linkedlisting1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Linkedlisting1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_linkedlisting1(inputs)
	return de_linkedlisting1(inputs)
});
export { linkedlisting1 as "linkedListing" }